import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import { PageContainer, useData } from '@cold-ambulance/ui';

import { OfferCard, OfferCardSkeleton } from '../../components/offer-card.tsx';

export default function RequestOffersPage() {
  const { t } = useTranslation();
  const { id } = useParams();
  const requestQuery = useData(
    'GET /requests/{id}',
    { id: id! },
    { enabled: !!id },
  );
  return (
    <PageContainer title={t('offers.allOffers')} showBackButton>
      {requestQuery.isLoading || !requestQuery.data ? (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <OfferCardSkeleton />
          <OfferCardSkeleton />
          <OfferCardSkeleton />
          <OfferCardSkeleton />
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          {requestQuery.data?.offers.map((offer, index) => (
            <OfferCard
              index={index + 1}
              key={offer.id}
              offer={offer}
              request={requestQuery.data}
            />
          ))}
        </div>
      )}
    </PageContainer>
  );
}
